import React, { useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { shallow } from "zustand/shallow";

import Typography from "@mui/material/Typography";

import NegativeFeedbackFormContent from "@app/analytics/TopicReport/components/NegativeFeedbackFormContent";
import useTopicReportFeedback from "@app/analytics/TopicReport/hooks/useTopicReportFeedback";
import useTopicReportStore from "@app/analytics/TopicReport/hooks/useTopicReportStore";
import { TopicReportFeedbackDetails } from "@app/analytics/TopicReport/types";
import ROUTES from "@app/common/routes";

import ConfirmationModal from "@rui/ConfirmationModal";

const RemoveTopicReportFeedbackModal = () => {
  const [show, setShow] = useTopicReportStore(
    (state) => [
      state.showRemoveFeedbackModal,
      state.setShowRemoveFeedbackModal,
    ],
    shallow
  );

  const [formError, setFormError] = useState<string | null>(null);
  const [details, setDetails] = useState<TopicReportFeedbackDetails>({
    reasons: [],
    otherDetail: "",
    action: "remove",
  });

  const { topicId } = useParams();
  const navigate = useNavigate();
  const { submitFeedback } = useTopicReportFeedback();

  if (!show || !topicId) return null;

  const handleConfirm = () => {
    submitFeedback.mutate(
      {
        topicId,
        feedback: {
          entityId: topicId,
          feedback: "negative",
          reasons: details.reasons,
          otherDetail: details.otherDetail,
          kind: "topic",
        },
      },
      {
        onSettled: () => {
          navigate(ROUTES.MEETING_REPORTS);
        },
      }
    );
  };

  const handleFormFieldChange = (
    values: Partial<TopicReportFeedbackDetails>
  ) => {
    const updatedValues = { ...details, ...values };
    setDetails(updatedValues);
  };

  return (
    <ConfirmationModal
      title={
        <>
          Why did you remove this Readout?
          <br />
          <Typography variant="bodySecondaryReg" color="shades.neutral.500">
            Your feedback helps us improve report accuracy.
          </Typography>
        </>
      }
      cancelProps={{ show: false }}
      confirmProps={{ label: "Submit feedback" }}
      onConfirm={handleConfirm}
      size="md"
      open={show}
      onClose={() => setShow(false)}
      loading={submitFeedback.isPending}
    >
      <NegativeFeedbackFormContent
        values={details}
        errorMessage={formError}
        onChange={handleFormFieldChange}
        onChangeErrorMessage={setFormError}
      />
    </ConfirmationModal>
  );
};

export default RemoveTopicReportFeedbackModal;
